import AuthInvitationToken from 'src/modules/auth/authInvitationToken';
import { AuthToken } from 'src/modules/auth/authToken';
import authAxios, {attributesAxios} from 'src/modules/shared/axios/authAxios';
import UsageLogService from 'src/modules/usageLog/usageLogService';


export default class AuthService {
  static async sendEmailVerification() {
    const response = await authAxios.post(
      '/auth/send-email-address-verification-email',
    );

    return response.data;
  }

  static async sendPasswordResetEmail(email) {
    const response = await authAxios.post(
      '/auth/send-password-reset-email',
      {
        email,
      },
    );

    return response.data;
  }

  static async registerWithEmailAndPassword(data) {
    const invitationToken = AuthInvitationToken.get();

    const response = await authAxios.post('/auth/sign-up', {
      ...data,
      invitationToken,
    });

    AuthInvitationToken.clear();

    return response.data;
  }

  static async signinWithEmailAndPassword(email, password) {
    const invitationToken = AuthInvitationToken.get();

    const response = await authAxios.post('/auth/sign-in', {
      email,
      password,
      invitationToken,
    });

    AuthInvitationToken.clear();

    return response.data;
  }

  static async signinWithEmailAndPasswordAlexa(
    email,
    password,
    redirect_uri,
    state,
  ) {
    const response = await authAxios.post(
      '/auth/o2/authorize',
      {
        email,
        password,
        redirectUri: redirect_uri,
        state,
      },
    );

    return response.data;
  }

  static async fetchMe() {
    const response = await authAxios.get('/auth/me');
    return response.data;
  }

  static signout() {
    AuthToken.set(null, true);
    UsageLogService.clearSessions();
  }

  static async updateProfile(data) {
    const body = {
      data,
    };

    const response = await authAxios.put(
      '/auth/profile',
      body,
    );

    return response.data;
  }

  static async changePassword(oldPassword, newPassword) {
    const body = {
      oldPassword,
      newPassword,
    };

    const response = await authAxios.put(
      '/auth/change-password',
      body,
    );

    return response.data?.authToken;
  }

  static async passwordReset(token, password) {
    const response = await authAxios.put(
      '/auth/password-reset',
      {
        token,
        password,
      },
    );

    return response.data;
  }

  static async phoneNumberVerifyCreate() {
    const response = await authAxios.post(
      '/auth/phone-number/verify',
    );
    return response.data;
  }

  static async phoneNumberVerifyConfirm(code) {
    const response = await authAxios.put(
      '/auth/phone-number/verify',
      {
        code,
      },
    );
    return response.data;
  }

  static async verifyEmail(token) {
    const response = await authAxios.put(
      '/auth/verify-email',
      {
        token,
      },
    );

    return response.data;
  }

  static async socialOnboard() {
    const invitationToken = AuthInvitationToken.get();

    const response = await authAxios.post(
      '/auth/social/onboard',
      {
        invitationToken,
      },
    );

    AuthInvitationToken.clear();

    return response.data;
  }

  static isSocialOnboardRequested() {
    const urlParams = new URLSearchParams(
      window.location.search,
    );

    return Boolean(urlParams.get('social'));
  }

  static async registerRokuCode(code) {
    const response = await authAxios.post(
      '/auth/roku-code',
      { code },
    );
    return response.data.code;
  }
  static async idmeCredentials() {
    const response = await authAxios.get(
      '/idMe/webCred'
    );
    return response.data;
  }
  static async idmeToken(data) {
    const response = await authAxios.post('/idMe/createAccessToken',data);
    return response.data;
  }
  static async storeIdmeResponse(data) {
    const response = await authAxios.post('/auth/store-IdMe-Response',data);
    return response.data;
  }
  static async checkCoupon(data) {
    const response = await authAxios.post('/plan/stripe/coupon-check',data);
    return response.data;
  }
  static async attributes(data) {
    const response = await attributesAxios(data);
    return response.data;
  }

  static async deleteAccount() {
    const response = await authAxios.delete('/auth/delete-account');
    return response.data;
  }
}
